"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var MobileIdentityService_1 = __importDefault(require("../services/MobileIdentityService"));
var network_1 = __importDefault(require("../services/network"));
var Tracker_1 = __importDefault(require("../services/tracking/Tracker"));
var config_1 = __importDefault(require("../../config"));
var CampaignManager_1 = require("./CampaignManager");
var GrowCore_1 = require("./GrowCore");
var BrowseAbandonmentListener_1 = require("../listeners/BrowseAbandonmentListener");
var GrowCoreFactory = /** @class */ (function () {
    function GrowCoreFactory() {
    }
    GrowCoreFactory.buildGrowCore = function (user, script, services, logger, sessionManager) {
        var apis = (0, network_1.default)(logger, services.localStorage);
        var mobileIdentityService = new MobileIdentityService_1.default(user, config_1.default.headerEnrichment, sessionManager, services.localStorage);
        var tracker = new Tracker_1.default({
            environment: services.browserEnvironment,
            logger: logger,
            network: apis.trackingApi,
            storage: services.localStorage,
            sessionManager: sessionManager,
            userID: user.id
        });
        var campaignManager = new CampaignManager_1.CampaignManager({
            services: services,
            logger: logger,
            currentScript: script,
            sessionManager: sessionManager,
            tracker: tracker,
            userID: user.id,
            configurations: config_1.default
        });
        if (user.browseAbandonment) {
            (0, BrowseAbandonmentListener_1.registerBrowseAbandonmentListener)({
                api: apis.trackingApi,
                browseAbandonmentRules: user.browseAbandonment,
                environment: services.browserEnvironment,
                localStorage: services.localStorage,
                logger: logger,
                sessionManager: sessionManager,
                userID: user.id
            });
            (0, BrowseAbandonmentListener_1.handlePageChange)({
                api: apis.trackingApi,
                browseAbandonmentRules: user.browseAbandonment,
                environment: services.browserEnvironment,
                localStorage: services.localStorage,
                logger: logger,
                sessionManager: sessionManager,
                userID: user.id
            });
        }
        return new GrowCore_1.GrowCore({
            user: user,
            apis: apis,
            sessionManager: sessionManager,
            localStorage: services.localStorage,
            logger: logger,
            browserEnvironment: services.browserEnvironment,
            campaignManager: campaignManager,
            mobileIdentityService: mobileIdentityService
        });
    };
    return GrowCoreFactory;
}());
exports.default = GrowCoreFactory;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsic3JjL2xpYi9jb3JlL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQ0EsNEZBQXFFO0FBQ3JFLGdFQUE4QztBQUM5Qyx5RUFBa0Q7QUFDbEQsd0RBQXlDO0FBRXpDLHFEQUFtRDtBQUNuRCx1Q0FBcUM7QUFHckMsb0ZBQTRHO0FBRTVHO0lBQUE7SUFvRUEsQ0FBQztJQW5FaUIsNkJBQWEsR0FBM0IsVUFDSSxJQUFVLEVBQ1YsTUFBeUIsRUFDekIsUUFBc0IsRUFDdEIsTUFBYyxFQUNkLGNBQThCO1FBRTlCLElBQU0sSUFBSSxHQUFHLElBQUEsaUJBQVksRUFBQyxNQUFNLEVBQUUsUUFBUSxDQUFDLFlBQVksQ0FBQyxDQUFBO1FBQ3hELElBQU0scUJBQXFCLEdBQUcsSUFBSSwrQkFBcUIsQ0FDbkQsSUFBSSxFQUNKLGdCQUFjLENBQUMsZ0JBQWdCLEVBQy9CLGNBQWMsRUFDZCxRQUFRLENBQUMsWUFBWSxDQUN4QixDQUFBO1FBRUQsSUFBTSxPQUFPLEdBQUcsSUFBSSxpQkFBTyxDQUFDO1lBQ3hCLFdBQVcsRUFBRSxRQUFRLENBQUMsa0JBQWtCO1lBQ3hDLE1BQU0sRUFBRSxNQUFNO1lBQ2QsT0FBTyxFQUFFLElBQUksQ0FBQyxXQUFXO1lBQ3pCLE9BQU8sRUFBRSxRQUFRLENBQUMsWUFBWTtZQUM5QixjQUFjLEVBQUUsY0FBYztZQUM5QixNQUFNLEVBQUUsSUFBSSxDQUFDLEVBQUU7U0FDbEIsQ0FBQyxDQUFBO1FBRUYsSUFBTSxlQUFlLEdBQUcsSUFBSSxpQ0FBZSxDQUFDO1lBQ3hDLFFBQVEsVUFBQTtZQUNSLE1BQU0sUUFBQTtZQUNOLGFBQWEsRUFBRSxNQUFNO1lBQ3JCLGNBQWMsZ0JBQUE7WUFDZCxPQUFPLFNBQUE7WUFDUCxNQUFNLEVBQUUsSUFBSSxDQUFDLEVBQUU7WUFDZixjQUFjLGtCQUFBO1NBQ2pCLENBQUMsQ0FBQTtRQUVGLElBQUksSUFBSSxDQUFDLGlCQUFpQixFQUFFO1lBQ3hCLElBQUEsNkRBQWlDLEVBQUM7Z0JBQzlCLEdBQUcsRUFBRSxJQUFJLENBQUMsV0FBVztnQkFDckIsc0JBQXNCLEVBQUUsSUFBSSxDQUFDLGlCQUF3RDtnQkFDckYsV0FBVyxFQUFFLFFBQVEsQ0FBQyxrQkFBa0I7Z0JBQ3hDLFlBQVksRUFBRSxRQUFRLENBQUMsWUFBWTtnQkFDbkMsTUFBTSxRQUFBO2dCQUNOLGNBQWMsZ0JBQUE7Z0JBQ2QsTUFBTSxFQUFFLElBQUksQ0FBQyxFQUFFO2FBQ2xCLENBQUMsQ0FBQTtZQUVGLElBQUEsNENBQWdCLEVBQUM7Z0JBQ2IsR0FBRyxFQUFFLElBQUksQ0FBQyxXQUFXO2dCQUNyQixzQkFBc0IsRUFBRSxJQUFJLENBQUMsaUJBQXdEO2dCQUNyRixXQUFXLEVBQUUsUUFBUSxDQUFDLGtCQUFrQjtnQkFDeEMsWUFBWSxFQUFFLFFBQVEsQ0FBQyxZQUFZO2dCQUNuQyxNQUFNLFFBQUE7Z0JBQ04sY0FBYyxnQkFBQTtnQkFDZCxNQUFNLEVBQUUsSUFBSSxDQUFDLEVBQUU7YUFDbEIsQ0FBQyxDQUFBO1NBQ0w7UUFFRCxPQUFPLElBQUksbUJBQVEsQ0FBQztZQUNoQixJQUFJLE1BQUE7WUFDSixJQUFJLE1BQUE7WUFDSixjQUFjLGdCQUFBO1lBQ2QsWUFBWSxFQUFFLFFBQVEsQ0FBQyxZQUFZO1lBQ25DLE1BQU0sUUFBQTtZQUNOLGtCQUFrQixFQUFFLFFBQVEsQ0FBQyxrQkFBa0I7WUFDL0MsZUFBZSxpQkFBQTtZQUNmLHFCQUFxQix1QkFBQTtTQUN4QixDQUFDLENBQUE7SUFDTixDQUFDO0lBQ0wsc0JBQUM7QUFBRCxDQUFDLEFBcEVELElBb0VDIn0=